/**
 * Подставляем человекочитаемый адрес по координатам маркера
 * @param {Object} location - Объект с координатами
 * @param {number} location.latitude - Широта
 * @param {number} location.longitude - Долгота
 * @returns {Promise<String>} - Человекочитаемый адрес
 */
export const getLocationText = async (location) => {
  const { latitude, longitude } = location;
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lon=${longitude}&lat=${latitude}`
    );
    if (!response.ok) {
      return;
    }

    const data = await response.json();

    if (data?.display_name) {
      return data.display_name;
    }
    return "";
  } catch (err) {
    throw err;
  }
};

/**
 * Ищем локации по текстовому запросу
 * @param {String} query - Текстовый запрос
 * @returns {Promise<Array>} - Массив найденных локаций
 */
export const searchLocation = async (query) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&limit=5&q=${encodeURIComponent(
      query
    )}`
  );
  if (!response.ok) {
    throw new Error("Search request failed");
  }
  return response.json();
};
